import { render } from "./RightLimit.vue?vue&type=template&id=02520c2a&scoped=true"
import script from "./RightLimit.vue?vue&type=script&lang=js"
export * from "./RightLimit.vue?vue&type=script&lang=js"

import "./RightLimit.vue?vue&type=style&index=0&id=02520c2a&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02520c2a"]])

export default __exports__